import GoAiguaButton from "components/generic/goaiguabutton";
import { useIntl } from "react-intl";

type RestoredButtonType = {
    restoreCallback: () => void;
    isBtnActive: boolean;
};

const RestoreButton = ({
    restoreCallback,
    isBtnActive,
}: RestoredButtonType) => {
    const intl = useIntl();
    return (
        <div className="c-body__btn-restored">
            <GoAiguaButton
                text={intl.formatMessage({
                    id: "app.components.restoreButton.restoreByDefault",
                })}
                onClick={() => {
                    restoreCallback();
                }}
                status={isBtnActive ? "enabled" : "disabled"}
            />
        </div>
    );
};

export default RestoreButton;
